import { Link } from "react-router-dom";
import { MyOrderRow, orderStep, useMyOrdersQuery } from "../../Redux/Api/WebOrder";
import { CiButton, CiTag, inrText } from "../../common/ci/Ui";
import { useCiT } from "../../common/ci/i18n";
import { hasStoredSession } from "../../utils/session";

/**
 * "Pichla order dobara" — home par logged-in dealer ke aakhri 3 web orders.
 * Rulebook §1 rule 4: repeat business hi B2B ka bada hissa hai.
 * Koi order na ho to kuch nahi dikhta.
 */
const fmt = (iso: string) => {
  const d = new Date(iso);
  return Number.isNaN(d.getTime())
    ? ""
    : d.toLocaleDateString("en-IN", { day: "numeric", month: "short" });
};

const RecentOrdersStrip = () => {
  // Bina login ke ye call sirf 401 laati hai — aur home page ke critical path
  // par baithti hai.
  const { data, isError } = useMyOrdersQuery({ page: 1, limit: 3 }, { skip: !hasStoredSession() });
  const orders: MyOrderRow[] = (data && data.orders) || [];
  const t = useCiT();
  if (isError || !orders.length) return null;

  return (
    <div className="flex flex-col gap-3 rounded-lg border border-ci-line bg-white p-4 sm:flex-row sm:items-center sm:gap-6 sm:p-5">
      <div className="flex min-w-[200px] flex-col">
        <span className="font-display text-[22px] font-bold uppercase leading-none text-ci-navy">
          {t("Pichla order dobara")}
        </span>
        <span className="text-[13px] text-ci-muted">{t("Aapke aakhri orders · 1 click me dekhein")}</span>
      </div>
      <div className="flex flex-1 flex-col gap-2 sm:flex-row sm:flex-wrap">
        {orders.map((o) => {
          const st = orderStep(o.status, o.approvalPending);
          return (
            <Link
              key={o.orderNumber}
              to={`/profile/my-orders/${encodeURIComponent(o.orderNumber)}`}
              className="flex min-w-[200px] flex-col gap-1 rounded-md border border-ci-line bg-ci-bg px-3.5 py-2.5 hover:border-ci-navy"
            >
              <span className="flex items-center gap-2">
                <b className="text-[14px]">{o.orderNumber}</b>
                <CiTag tone={st.tone}>{st.label}</CiTag>
              </span>
              <span className="text-[13px] text-ci-muted">
                {o.itemCount} {t("items")} · {inrText(o.grandTotal)} · {fmt(o.createdAt)}
              </span>
            </Link>
          );
        })}
      </div>
      <Link to="/profile/my-orders" className="sm:ml-auto">
        <CiButton variant="navy" size="sm">{t("My orders")}</CiButton>
      </Link>
    </div>
  );
};

export default RecentOrdersStrip;
